import React from 'react';
import CardBitcoin from './CardBitcoin';

const CarouselBitcoins = ({ coins }) => {
  const renderedList = coins.map((coin) => {
    return (
      <div className='col-lg-4 col-md-6'>
        <CardBitcoin key={coin.name} coin={coin} />
      </div>
    );
  });

  return (
    <div>
      <section id='carousel'>
        <div className='container pt-5 pb-5 texto-crypto'>
          <h1 className='text-center mb-5 '>Nuestras Crypto</h1>
          <div className='row justify-content-center'>{renderedList}</div>
        </div>
      </section>
    </div>
  );
};

export default CarouselBitcoins;
